/**
 * <tv-rail> — a scroll rail with arrows.
 *
 * The track is a plain overflow-x element, so touch swipe, trackpad and
 * keyboard all work with no JS at all; this only adds the desktop arrows and
 * hides them when there is nothing to scroll to.
 */
class TreviiaRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-tv-rail-track]');
    this.prev = this.querySelector('[data-tv-rail-prev]');
    this.next = this.querySelector('[data-tv-rail-next]');
    if (!this.track) return;

    this.sync = this.sync.bind(this);

    this.prev?.addEventListener('click', () => this.scrollByPage(-1));
    this.next?.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', this.sync, { passive: true });

    this.ro = new ResizeObserver(this.sync);
    this.ro.observe(this.track);

    this.sync();
  }

  disconnectedCallback() {
    this.ro?.disconnect();
    this.track?.removeEventListener('scroll', this.sync);
  }

  scrollByPage(dir) {
    // Page by ~80% of the visible width so the shopper keeps a landmark item.
    this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: 'smooth' });
  }

  sync() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    // 2px of slack: sub-pixel widths otherwise leave the arrow permanently on.
    const overflows = scrollWidth - clientWidth > 2;
    if (this.prev) this.prev.hidden = !overflows || scrollLeft <= 2;
    if (this.next) this.next.hidden = !overflows || scrollLeft >= scrollWidth - clientWidth - 2;
  }
}

if (!customElements.get('tv-rail')) customElements.define('tv-rail', TreviiaRail);
